<template>
  <v-row
    no-gutters
    class="align-center flex-nowrap py-1 handleDrag element"
    :class="classes"
    :style="{ 'background-color': backgroundColor }"
  >
    <v-col cols="auto" v-if="level > 1 || isRight">
      <layer-style-preview-icon is-icon :layer-type="getLayerType(layer)" :layer-style="layerStyle" />
    </v-col>
    <v-col
      cols="auto"
      style="width: calc(100% - 45px)"
      class="text-truncate text-body-2 text-left"
      :class="{ 'pl-2': level > 1 || isRight, 'text--disabled': disabled }"
    >
      {{ name }}
    </v-col>
    <v-spacer />
    <v-col cols="auto">
      <dots-menu
        :disabled="disabled"
        font-size="19px"
        :items="computedDotsItems"
        @manageCard="$emit('manageCard', $props)"
        @changeGroupName="$emit('changeGroupName', $props)"
        @manageLayer="$emit('manageLayer', $props, layer)"
        @copyLayer="$emit('copyLayer', $props, layer)"
        @deleteFromSystem="$emit('deleteFromSystem', $props)"
        @delete="$emit('delete', $props)"
        @changeSymbolization="$emit('changeSymbolization', $props)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';
import DotsMenu from '@/components/DotsMenu';
import LayerStylePreviewIcon from '@/components/LayerStylePreviewIcon';

import stylePreviewUtilities from '@/mixins/stylePreviewUtilities';

export default {
  name: 'DraggableListsLayersItem',
  mixins: [stylePreviewUtilities],
  components: {
    DotsMenu,
    LayerStylePreviewIcon,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    isRight: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      required: true,
    },
    dotsItems: {
      type: Array,
      default: () => [
        {
          name: 'manageLayer',
        },
        {
          name: 'manageCard',
        },
        {
          name: 'changeSymbolization',
        },
        {
          name: 'deleteFromSystem',
        },
        {
          name: 'copyLayer',
        },
      ],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    role: {
      type: String,
      default: '',
    },
  },
  computed: {
    layer: get('layers/layers@:id'),
    layerStyle() {
      if (this.layer) {
        return this.layer.style_web;
      }
      return undefined;
    },
    classes() {
      if (this.isRight) {
        return ['border', 'px-4'];
      }
      return this.level > 1 ? [`px-${this.level * 2}`, 'border'] : [];
    },
    backgroundColor() {
      return this.level > 1 ? 'rgb(231, 231, 231, 0.5)' : 'white';
    },
    computedDotsItems() {
      let dotsItems = JSON.parse(JSON.stringify(this.dotsItems));
      if (this.type === 'service_layer') {
        dotsItems = dotsItems.filter(item => item.name !== 'manageCard');
      }
      if (this.role) {
        dotsItems = dotsItems.filter(item => item.name !== 'deleteFromSystem');
      }
      if (!this.layer?.geometry_type) {
        dotsItems = dotsItems.filter(item => item.name !== 'changeSymbolization');
      }
      return dotsItems;
    },
  },
};
</script>

<style scoped lang="scss">
ul {
  padding-left: 0;
  list-style: none;
}
.border {
  margin-bottom: 4px;
  @include border(top);
  @include border(right);
  @include border(left);
  &:last-child {
    @include border(bottom);
  }
}
</style>
